import React from 'react';
import { Link } from "react-router-dom";
import Header from './Header';
import Footer from './Footer';

const Home = () => {
    return (
        <div className="app-container">
            <Header />



            {/* Intro Section */}
            <section className="intro-section">
                <div className="intro-text">
                    <h2>युवा मोर्चा के साथ जुड़ें और समाज में बदलाव लाएं</h2>
                    <p>
                        राष्ट्रीय युवा मोर्चा, युवाओं का एक संगठन है जो देश के युवाओं की एकजुट और सशक्त आवाज के रूप में काम कर रहा है। यह संगठन पिछले कई वर्षों से निरंतर अपनी राष्ट्रीय और सामाजिक जिम्मेदारियों को निभाते हुए समाज के उत्थान के लिए प्रयासरत है। युवा मोर्चा जन अपेक्षाओं के अनुसार अपने कार्यों को अंजाम देता है और समाज के विकास के लिए निरंतर काम कर रहा है।
                        <br /><br />
                        राष्ट्रीय युवा मोर्चा द्वारा कई रचनात्मक और सेवा कार्यों को बढ़ावा दिया गया है। इनमें प्रमुख रूप से आत्मनिर्भर युवा केंद्र, निःशुल्क पुस्तकालय, सामाजिक चेतना और आध्यात्मिक जागृति अभियान, सामूहिक विवाह आयोजन, मुफ्त सामूहिक भोजन व्यवस्था, और रोगियों के लिए निःशुल्क जांच सुविधाएं शामिल हैं। ये सभी कार्यक्रम संगठन द्वारा समाज के प्रत्येक वर्ग को लाभ पहुँचाने के लिए आयोजित किए जाते हैं।
                        <br /><br />
                        यह संगठन न केवल युवाओं को एकजुट करता है, बल्कि समाज में सामाजिक, आध्यात्मिक और सांस्कृतिक जागरूकता भी फैलाता है।
                        <br /><br />
                        <strong>उज्ज्वल कुमार शर्मा</strong> <br />
                        राष्ट्रीय अध्यक्ष (कार्यकारणी), <br />
                        <span className="highlight">राष्ट्रीय युवा मोर्चा</span>
                        <br /><br />
                        युवा शक्ति ज़िंदाबाद
                    </p>


                    <div className="cta-buttons">
                        <a href={`https://www.facebook.com/RashtriyaYuvaMorcha.in`} target="_blank" rel="noopener noreferrer">
                            <button className="join-button">हमसे जुड़ें</button>
                        </a>
                        <Link to="/about-us">
                            <button className="learn-more-button">और जानें</button>
                        </Link>
                    </div>
                </div>
                <img
                    src="/ujjawal1.png"
                    alt="National Youth Front"
                    className="intro-image"
                />
            </section>

            {/* New Section for Manoj Kumar Singh */}
            <section className="intro-section">
                <div className="intro-text">
                    <h2>राष्ट्रीय नेतृत्व के प्रतीक: मनोज कुमार सिंह</h2>
                    <p>
                        <strong>मनोज कुमार सिंह</strong>, राष्ट्रीय अध्यक्ष के रूप में संगठन के लिए अद्वितीय नेतृत्व और प्रेरणा का प्रतीक हैं। उनकी दूरदृष्टि और कुशल नेतृत्व ने संगठन को नई ऊँचाइयों तक पहुँचाने में महत्वपूर्ण भूमिका निभाई है। वे हर वर्ग और समाज के लिए प्रेरणा स्रोत हैं।
                        <br /><br />
                        मनोज कुमार सिंह ने राष्ट्रीय स्तर पर कई उल्लेखनीय पहल और अभियानों का संचालन किया है। इनमें ग्रामीण विकास, शिक्षा सुधार, महिला सशक्तिकरण, पर्यावरण संरक्षण, और स्वच्छता अभियान जैसे प्रमुख कार्य शामिल हैं। उनकी सोच और योजनाएँ समाज को समृद्ध और प्रगतिशील बनाने के लिए समर्पित हैं।
                        <br /><br />
                        उनका उद्देश्य सभी नागरिकों को एकजुट करना और उन्हें देश के विकास में सक्रिय भागीदारी के लिए प्रेरित करना है। उनके नेतृत्व में संगठन ने समावेशी विकास और सामाजिक कल्याण के क्षेत्र में अनगिनत मील के पत्थर स्थापित किए हैं।
                        <br /><br />
                        <strong>मनोज कुमार सिंह</strong> <br />
                        राष्ट्रीय अध्यक्ष, <br />
                        <span class="highlight">राष्ट्रीय युवा मोर्चा</span>
                        <br /><br />
                        संगठित भारत की जय
                    </p>
                </div>
                <img
                    src="/rashtriyayuvamorcha2.png"
                    alt="Manoj Kumar Singh"
                    className="new-section-image"
                />
            </section>



            {/* New Section for Manoranjan Singh Manu */}
            <section className="intro-section">
                <div className="intro-text">
                    <h2>युवा नेतृत्व के प्रतीक: मनोरंजन सिंह मनु</h2>
                    <p>
                        राष्ट्रीय युवा मोर्चा के प्रेरणादायक अध्यक्ष, <strong>मनोरंजन सिंह मनु</strong>, संगठन के लिए एक आदर्श नेतृत्वकर्ता हैं। उनके मार्गदर्शन में युवा मोर्चा ने नई ऊँचाइयों को छुआ है। उनकी दृष्टि और समर्पण ने समाज के हर वर्ग को जागरूक और सशक्त बनाने में महत्वपूर्ण भूमिका निभाई है।
                        <br /><br />
                        मनोरंजन सिंह मनु ने युवाओं के लिए कई क्रांतिकारी कार्यक्रम और अभियानों को संचालित किया है। इनमें रोजगार मेलों का आयोजन, डिजिटल शिक्षा अभियान, खेल-कूद प्रोत्साहन और युवाओं के लिए स्वास्थ्य और कल्याण सेवाएं शामिल हैं।
                        <br /><br />
                        उनका उद्देश्य युवाओं को सशक्त बनाना और उन्हें देश के निर्माण में योगदान देने के लिए प्रेरित करना है। वे अपने सामाजिक कार्यों और संगठनात्मक कौशल के लिए जाने जाते हैं।
                        <br /><br />
                        <strong>मनोरंजन सिंह मनु</strong> <br />
                        राष्ट्रीय युवा अध्यक्ष, <br />
                        <span class="highlight">राष्ट्रीय युवा मोर्चा</span>
                        <br /><br />
                        युवा शक्ति की जय
                    </p>

                </div>
                <img
                    src="/manoranjansinghmanu.png"
                    alt="Manoranjan Singh Manu"
                    className="new-section-image"
                />
            </section>

            <main className="main-content">
                <section className="section">
                    <h2>राष्ट्रीय युवा मोर्चा की भूमिका</h2>
                    <p>
                        राष्ट्रीय युवा मोर्चा का मुख्य उद्देश्य युवाओं को सशक्त बनाना और उन्हें समाज में सक्रिय भागीदार बनाना है।
                    </p>
                    <ul>
                        <li>युवाओं को सशक्त करना</li>
                        <li>नेतृत्व विकास</li>
                        <li>राजनीतिक और सामाजिक जागरूकता</li>
                    </ul>
                </section>

                <section className="section">
                    <h2>राष्ट्रीय युवा मोर्चा के प्रमुख उद्देश्य</h2>
                    <p>
                        राष्ट्रीय युवा मोर्चा के उद्देश्य युवाओं को सक्षम और जिम्मेदार नागरिक बनाने से जुड़े हैं।
                    </p>
                    <ul>
                        <li>शैक्षिक सशक्तिकरण</li>
                        <li>स्वास्थ्य और कल्याण</li>
                        <li>राजनीतिक जागरूकता</li>
                        <li>सामाजिक जागरूकता</li>
                    </ul>
                </section>

                <section className="section">
                    <h2>प्रमुख कार्यक्रम और अभियानों की योजना</h2>
                    <ul>
                        <li>स्वच्छता अभियान</li>
                        <li>रक्तदान अभियान</li>
                        <li>महिला सशक्तिकरण अभियान</li>
                        <li>शिक्षा और कौशल विकास कार्यक्रम</li>
                        <li>पर्यावरण संरक्षण अभियान</li>
                    </ul>
                </section>

                <section className="section">
                    <h2>संगठनात्मक संरचना</h2>
                    <p>
                        राष्ट्रीय युवा मोर्चा का ढांचा चार स्तरों पर है: केंद्रिय, राज्य, जिला, और स्थानीय स्तर। हर स्तर पर अलग-अलग जिम्मेदारियां होती हैं।
                    </p>
                </section>

                <section className="section">
                    <h2>सोशल मीडिया और डिजिटल प्लेटफार्म</h2>
                    <p>
                        संगठन को प्रभावी ढंग से बढ़ावा देने के लिए सोशल मीडिया और डिजिटल प्लेटफार्म का उपयोग किया जाता है। अभियान चलाने के लिए फेसबुक, इंस्टाग्राम, और यूट्यूब का प्रभावी उपयोग किया जाता है।
                    </p>
                </section>
            </main>

            <Footer />
        </div>
    );
};

export default Home;
